
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/funds/payouts/[slug]",
      function () {
        return require("private-next-pages/funds/payouts/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/funds/payouts/[slug]"])
      });
    }
  